import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

// Avalon Header — TOP-CENTRE micro-nav with brand mark CENTERED, no rectangle bar
// Distinctive: numbered dots beside each nav link; on scroll the bar gets thinner
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all duration-700 ${scrolled ? 'py-3 bg-[#0A1F2E]/85 backdrop-blur-md' : 'py-6 bg-transparent'}`}>
      <div className="max-w-[1440px] mx-auto px-8 lg:px-14 flex items-center justify-between gap-8">
        <button onClick={() => setPage('home')} className="text-[#E8DDC7] flex items-baseline gap-2" data-testid="yacht-logo">
          <span className="font-serif italic text-2xl">{META.brand}</span>
          <span className="hidden sm:inline font-mono text-[9px] tracking-[0.4em] uppercase opacity-60">/ {META.tagline}</span>
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {ROUTES.map((r, i) => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`yacht-nav-${r.id}`}
              className={`group flex items-center gap-2.5 font-mono text-[10px] tracking-[0.25em] uppercase transition-colors ${page === r.id ? 'text-[#B68F4E]' : 'text-[#E8DDC7]/70 hover:text-[#E8DDC7]'}`}>
              <span className={`w-1.5 h-1.5 rounded-full transition-colors ${page === r.id ? 'bg-[#B68F4E]' : 'bg-[#E8DDC7]/30 group-hover:bg-[#E8DDC7]'}`} />
              <span className="opacity-60">0{i + 1}</span>
              <span>{r.label}</span>
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('charter')} className="font-mono text-[10px] tracking-[0.28em] uppercase border border-[#B68F4E]/60 text-[#B68F4E] px-4 py-2 hover:bg-[#B68F4E] hover:text-[#0A1F2E] transition-colors" data-testid="yacht-cta-charter">
          Enquire →
        </button>
      </div>
    </header>
  );
}
